import { useEffect, useState } from 'react';

export const DEFAULT_VISIBLE_DEVICE_OFFERS = 8;

export const useVisibleProducts = <T>(offers: T[], initialVisibleCount = DEFAULT_VISIBLE_DEVICE_OFFERS) => {
  const [visibleCount, setVisibleCount] = useState(initialVisibleCount);

  useEffect(() => {
    setVisibleCount(initialVisibleCount);
  }, [initialVisibleCount, offers.length]);

  const visibleOffers = offers.slice(0, visibleCount);
  const hasMoreOffers = visibleCount < offers.length;

  const showMore = () => {
    setVisibleCount(current => Math.min(current + initialVisibleCount, offers.length));
  };

  return {
    visibleOffers,
    hasMoreOffers,
    showMore,
  };
};
